// extracted by mini-css-extract-plugin
export default {"title":"YmXB23qr"};